module.exports = __webpack_public_path__ + "img/Rectangle.04a2b143.svg";